import axios from "axios"
import { BASE_URL } from "@/composables/url_config"

export function useMaintenanceCheck() {
  async function checkMaintenanceStatus() {
    try {
      const result = await axios.get(BASE_URL + '/home/check_api_online')
      const data = result.data
      return {
        underMaintenance: data.under_maintenance === true,
        finishTime: data.under_maintenance_finish_time || '2'
      }
    } catch (e) {
      console.error('Error checking maintenance status:', e)
      return { underMaintenance: false, finishTime: '2' }
    }
  }

  async function checkApiReachable(timeoutMs = 5000) {
    try {
      const controller = new AbortController()
      const timeout = setTimeout(() => controller.abort(), timeoutMs)
      const result = await axios.get(BASE_URL + '/home/check_api_online', {
        signal: controller.signal
      })
      clearTimeout(timeout)
      return {
        reachable: true,
        underMaintenance: result.data.under_maintenance === true,
        finishTime: result.data.under_maintenance_finish_time || '2'
      }
    } catch (e) {
      return { reachable: false, underMaintenance: false, finishTime: '2' }
    }
  }

  return { checkMaintenanceStatus, checkApiReachable }
}
